import { useAuth } from './useAuth';

/**
 * Hook to check if current user is admin
 */
export function useIsAdmin(): boolean {
  const { user } = useAuth();
  return user?.profile?.role === 'admin';
}

/**
 * Hook to check if current user is accountant
 */
export function useIsAccountant(): boolean {
  const { user } = useAuth();
  return user?.profile?.role === 'accountant' || user?.profile?.tier === 'accountant';
}

/**
 * Hook that returns accountant status and loading state, to avoid flash of wrong nav
 */
export function useAccountantRole(): { isAccountant: boolean; isLoading: boolean } {
  const { user, isLoading } = useAuth();
  return {
    isAccountant: user?.profile?.role === 'accountant' || user?.profile?.tier === 'accountant',
    isLoading,
  };
}
